import { create } from "zustand";

type RealtimeStatus = string;

type RealtimeState = {
	status: RealtimeStatus;
	setStatus: (status: RealtimeStatus) => void;
};

/**
 * Zustand store for realtime connection status.
 */
export const useRealtimeStore = create<RealtimeState>((set) => ({
	status: "idle",
	setStatus: (status) => set({ status }),
}));
